<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4.75 10C4.75 9.17155 5.42157 8.5 6.25 8.5H13.75C14.5784 8.5 15.25 9.17155 15.25 10V15.25C15.25 16.0784 14.5784 16.75 13.75 16.75H6.25C5.42157 16.75 4.75 16.0784 4.75 15.25V10Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 8.125V6.25C13 4.59314 11.6568 3.25 10 3.25C8.34314 3.25 7 4.59314 7 6.25V8.125" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'LockedIconV2',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>